<template>
  <div
    v-show="tags.length"
    class="blog-articles-filter-by-tags"
    :class="{ '-expanded': allTagsShown }"
  >
    <div class="blog-articles-filter-header mb-1">
      <div>{{ $t('BlogListing.tags.label') }}</div>
      <IRBaseButton
        v-if="shouldShowResetAll"
        x-small
        @click="resetSelectedTagsHandler"
      >
        {{ $t('BlogListing.resetAll.button.label') }} ({{ selected.length }})
      </IRBaseButton>
    </div>
    <div class="blog-articles-filter-tags">
      <IRChipGroup v-model="selected" @change="changeTagFilterHandler">
        <IRChip
          v-for="(tag, index) in tags"
          :key="tag"
          :value="tag"
          :class="{ '-hidden': isTagHidden(index) }"
          :selected="isTagActive(tag)"
          :disabled="!isOnline"
          @update:selected="toggleTag"
        >
          {{ tag }}
        </IRChip>
      </IRChipGroup>
    </div>
    <div class="blog-articles-filter-tags-bottom mt-2">
      <IRBaseButton
        text-color="var(--primary-color)"
        small
        @click="toggleTagsVisibility"
      >
        {{ toggleTagsVisibilityLabel }}
        <BaseSpriteIcon icon-name="ico-arrow-chevron"></BaseSpriteIcon>
      </IRBaseButton>
    </div>
  </div>
</template>
<script>
import BlogEvents from '@/enums/BlogEventsEnum';
import { mapGetters } from 'vuex';
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import IRChipGroup from '@/components/base/IRChipGroup/IRChipGroup.vue';
import IRChip from '@/components/base/IRChip/IRChip.vue';
import IRBaseButton from '@/components/base/IRBaseButton/IRBaseButton.vue';

const MIN_VISIBLE_MOBILE_TAGS = 3;

export default {
  name: 'BlogArticlesFilterByTags',
  components: {
    BaseSpriteIcon,
    IRBaseButton,
    IRChipGroup,
    IRChip
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    tagsSelected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: [],
      allTagsShown: false
    };
  },
  computed: {
    ...mapGetters({
      isOnline: 'ContextStore/isOnline'
    }),

    narrow() {
      return this.$store.getters['MediaDetectorStore/mediaSize'].narrow;
    },

    shouldShowResetAll() {
      return this.selected?.length > 0;
    },

    shouldShowToggleTagsVisibility() {
      return this.tags?.length >= MIN_VISIBLE_MOBILE_TAGS;
    },

    toggleTagsVisibilityLabel() {
      return this.allTagsShown
        ? this.$t('BlogListing.showLess.button.label')
        : this.$t('BlogListing.showAll.button.label');
    }
  },
  watch: {
    tagsSelected(tags) {
      this.selected = [...this.selected, ...tags];
    }
  },
  methods: {
    isActiveTag(tag) {
      return this.selected.includes(tag);
    },
    toggleTag(tag) {
      const selectedTags = [...this.selected];
      const tagIndex = selectedTags.indexOf(tag);
      if (tagIndex !== -1) {
        selectedTags.splice(tagIndex, 1);
      } else {
        selectedTags.push(tag);
      }
      this.selected = selectedTags;
      this.changeTagFilterHandler(selectedTags);
    },
    changeTagFilterHandler(selected) {
      this.$emit('onChangeTagFilter', {
        type: BlogEvents.FILTER_BY_TAG,
        data: selected
      });
    },
    resetSelectedTagsHandler() {
      this.$emit('onChangeTagFilter', {
        type: BlogEvents.RESET_SELECTED_TAGS
      });
      this.selected = [];
    },
    isTagActive(tag) {
      return this.selected.indexOf(tag) !== -1;
    },
    isTagHidden(index) {
      return (
        this.narrow && !this.allTagsShown && index >= MIN_VISIBLE_MOBILE_TAGS
      );
    },
    toggleTagsVisibility() {
      this.allTagsShown = !this.allTagsShown;
    }
  }
};
</script>

<style lang="less" src="./BlogArticlesFilterByTags.less"></style>
